module.exports = __webpack_public_path__ + "static/hayesandjarvis-cb88babfecd16d1996aeb39d0ff8dd5c.jpg";